module.exports = __webpack_public_path__ + "static/media/Page07.2bd8beed.png";